import { Button, Flex, IconButton, InputGroup, Text, useBoolean, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

import { Input as InputForm } from "@/components/Input";
import { AuthContext, useAuth } from "@/contexts";
import Router from "next/router";
import { useContext, useState } from "react";

type Inputs = {
  email: string;
  password: string;
};

interface CardLoginProps {
  checkout?: boolean;
  closeFn?: () => void;
}

export function CardLoginHasAccount({ checkout, closeFn }: CardLoginProps) {
  const { handleSubmit, register } = useForm();
  const [ShowPassword, setShow] = useBoolean();
  const [email, setEmail] = useState(String);
  const [password, setPassword] = useState(String);
  const User = useAuth();
  const toast = useToast({
    position: "bottom",
    duration: 3000,
    isClosable: true
  });

  const { signIn } = useContext(AuthContext);
  async function handleSignIn(data: Inputs) {
    signIn({ UserEmail: email, password })
      .then((response) => {
        if (response.status) {
          toast.closeAll();
          toast({
            title: "Login realizado com sucesso",
            status: "success",
            containerStyle: {
              color: "white",
              fontFamily: "arial",
              fontWeight: "100"
            },
            onCloseComplete: () => {
              if (checkout) {
                Router.push("/checkout/entrega");
                return;
              }

              if (Router.pathname === "/login") {
                Router.push("/minhaconta");
                return;
              } else if (Router.pathname === "/cadastro") {
                Router.push("/login");
                return;
              } else {
                Router.push(Router.pathname);
                return;
              }
            }
          });
        } else {
          toast.closeAll();
          toast({
            title: "Erro ao realizar login",
            status: "error",
            containerStyle: {
              color: "white",
              fontFamily: "arial",
              fontWeight: "100"
            },
            description: response.message
          });
        }
      })
      .catch((error) => {
        toast.closeAll();
        toast({
          title: "Erro ao realizar login",
          status: "error",
          containerStyle: {
            color: "white",
            fontFamily: "arial",
            fontWeight: "100"
          },
          description: error.message
        });
      });
  }

  return (
    <Flex w="full" justify="center" as="form" onSubmit={handleSubmit(handleSignIn)}>
      <Flex w="300px" direction="column" alignItems="center">
        <InputForm
          {...register("email", {
            value: email,
            onChange: (e) => setEmail(e.target.value)
          })}
          as="input"
          type="email"
          placeholder="E-mail"
          w={"full"}
          borderRadius={"50px"}
          mb="1rem"
        />
        <InputGroup
          display="flex"
          alignItems="center"
          mb="2rem"
          border="2px solid"
          borderRadius={"50px"}
          borderColor="gray.300"
          _hover={{
            borderColor: "black"
          }}
          _focusWithin={{
            borderColor: "black"
          }}
        >
          <InputForm
            {...register("password", {
              value: password,
              onChange: (e) => setPassword(e.target.value)
            })}
            as="input"
            border="none"
            type={ShowPassword ? "text" : "password"}
            placeholder="Senha"
            w={"full"}
            borderRadius={"50px"}
          />
          <IconButton
            aria-label="Mostrar senha"
            variant="none"
            icon={ShowPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
            onClick={setShow.toggle}
            _focus={{ border: "none" }}
            mr="5px"
          />
        </InputGroup>

        <Button variant={"primary-button"} _hover={{ opacity: "0.5" }} type="submit" w="full">
          ENTRAR
        </Button>
        <Text
          cursor={"pointer"}
          mt={"15px"}
          color={"ll-blue.main"}
          _hover={{ opacity: "0.5" }}
          onClick={() => Router.push("/recuperar-senha/enviar-email")}
        >
          Recuperar senha
        </Text>
      </Flex>
    </Flex>
  );
}
